import { MASCOTE_SPACE_TCHAU } from "../appAssistenteIA.constants";

export default function MessageAvatar() {
	return (
		<span className="flex h-15 w-15 shrink-0 items-center justify-center overflow-hidden rounded-full border bg-white shadow-sm">
			<img src={MASCOTE_SPACE_TCHAU} alt="" className="h-18 w-18 object-cover object-top" />
		</span>
	);
}
